import * as Home from '@/src/experiences/home'

export default Home.Screens.HomeIndex
